import { IObstetricaLabResultOption, IObstetricaLabResultsGroup, LabObservationObstetricalFile } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { ObstetricalFileLabObservationsDetails } from "./ObstetricalFileLabObservationsDetails";

interface ObstetricalFileLabObservationsContainerProps {
    id: string;
    observationGroups: IObstetricaLabResultsGroup[];
    finalEDB: Date;
    import: (value: LabObservationObstetricalFile, options: IObstetricaLabResultOption, trimester?: number) => void;
}

class ObstetricalFileLabObservationsContainer extends BaseReactComponent<ObstetricalFileLabObservationsContainerProps> {
    public render(): JSX.Element {
        return (
            <div className="lab-widget">
                {this.props.observationGroups
                    .filter(observationGroup =>
                        // hide categories with no recent data
                        observationGroup.options.showResultTypeEvenIfThereIsNoRecentResult
                        || !this.props.finalEDB
                        // 5 week before pregnancy start
                        || observationGroup.values.any(p => (42 - LuxonDateHelper.dateDiff(p.CollectionDate, this.props.finalEDB, "weeks")) > -5)
                    )
                    .map(observationGroup => (
                        <div key={`ObstetricalFileLabObservationsDetails_${observationGroup.key}`}>
                            <ObstetricalFileLabObservationsDetails
                                id={this.props.id}
                                observationGroup={observationGroup}
                                finalEDB={this.props.finalEDB}
                                import={this.props.import}
                            />
                        </div>
                    ))}
            </div>
        );
    }
}

export { ObstetricalFileLabObservationsContainer };
